import {alpha, createTheme} from '@mui/material/styles';

export const gallerySurface = (theme) => alpha(theme.palette.background.paper, .76);

export const galleryColors = {
    light: {background: '#F6F3ED', paper: '#FFFDFA', text: '#252521', muted: '#6C6860', accent: '#A64B38', border: '#DDD7CD'},
    dark: {background: '#191917', paper: '#23231F', text: '#F1EDE5', muted: '#B9B3A8', accent: '#DBA48B', border: '#44443B'},
};
export const automaticMode = (date = new Date()) => date.getHours() >= 19 || date.getHours() < 7 ? 'dark' : 'light';
export const createPublicTheme = (mode) => {
    const c = galleryColors[mode];
    return createTheme({
        palette: {mode, primary: {main: c.accent}, secondary: {main: c.accent},
            background: {default: c.background, paper: c.paper}, text: {primary: c.text, secondary: c.muted}, divider: c.border},
        typography: {fontFamily: '"Source Sans Pro", -apple-system, "Segoe UI", Arial, sans-serif',
            h1: {fontFamily: 'Georgia, "Times New Roman", serif'}, h2: {fontFamily: 'Georgia, "Times New Roman", serif'},
            h3: {fontFamily: 'Georgia, "Times New Roman", serif'}},
        shape: {borderRadius: 8},
        components: {
            MuiLink: {styleOverrides: {root: {'&&&&:hover': {color: c.accent}}}},
            MuiPaper: {styleOverrides: {root: {backgroundImage: 'none'}}},
            MuiButton: {styleOverrides: {root: {textTransform: 'none', boxShadow: 'none'}}},
        },
    });
};
export const publicTheme = createPublicTheme('light');
